import { metaFields } from './metaFields'

const formCopyBlock = /* groq */ `
    ...,
    markDefs[]{
      ...,
      internalPage->{
        _type,
        slug{
            current
        }
      },
    },
`

export const form = /* groq */ `
  _id,
  title,
  slug,
  ${metaFields},
  overrideTitle,
  inactive,
  copy[]{
    ...,
    markDefs[]{
      ...,
      internalPage->{
        _type,
        slug{
          current
        }
      },
    },
  },
  confirmationCopy[]{
    ...,
    markDefs[]{
      ...,
      internalPage->{
        _type,
        slug{
          current
        }
      },
    },
  },
  inactiveCopy[]{
    ...,
    markDefs[]{
      ...,
      internalPage->{
        _type,
        slug{
          current
        }
      },
    },
  },
  inputs[] {
    ...,
    _type == "resaleEventDates" => {
      "events": 
        *[_type == "event" && (ticketedEvent == true || ballotedEvent == true) && noResell != true] | order(title asc) {
          title,
          "slug": slug.current,
          ballotedEvent,
          eventDates[] {
            eventStart,
            eventEnd
          }
        }
    },
    _type == "waitlistEvents" => {
      "options": 
        *[_type == "event" && (ticketedEvent == true || ballotedEvent == true) && noWaitlist != true  ] | order(title asc) {
          title,
          "slug": slug.current,
          ballotedEvent,
          "eventStart": eventDates[].eventStart
        }
    },
    _type == "ballotedEvents" => {
      "options":
        *[_type == "event" && ballotedEvent == true ] | order(title asc) {
          title,
          "slug": slug.current
        }
    }
  }
`
